/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { AutoSyncCounts } from './autoSyncCounts';

export interface AddFromSearchResponse {
  added: number;
  skipped: number;
  job_candidate_ids?: string[];
  auto_sync?: AutoSyncCounts | null;
}
